import asyncLoadJs from './asyncLoadJs';

export default () => {
  var http =
    '//sdk.talkingdata.com/app/h5/v1?appid=9B9D925CE2DE4774B742768332C0634D';
  var https =
    '//jic.talkingdata.com/app/h5/v1?appid=9B9D925CE2DE4774B742768332C0634D';
  var script = /https/.test(window.location.protocol) ? https : http;
  var vn = 'web';
  var vc = 1.0;
  return asyncLoadJs(`${script}&vn=${vn}&vc=${vc}`);
};
